module.exports = __webpack_public_path__ + "assets/2891b38381a89a002f9ae9531ff668ac.mp3";